import { render, staticRenderFns } from "./ApproveProfil.vue?vue&type=template&id=537fb0e8"
import script from "./ApproveProfil.vue?vue&type=script&lang=js"
export * from "./ApproveProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports